<template>
  <v-container fluid class="pa-0 mo-bg" style="min-height: 87vh;">
    <v-row class="ma-5 pa-5" align="center" justify="center">
      <v-col cols="12" sm="11" md="10" lg="9">
        <v-sheet class="mo-panel elevation-0 rounded-l mx-auto" max-width="1000">
          <div class="position-relative">
            <canvas ref="bgCanvas" class="bg-canvas"></canvas>
            <div class="pa-6">
              <v-row dense>
                <v-col cols="12" md="6">
                  <v-card class="menu-card passet elevation-2" :ripple="true" @click="gotoPassetPrinting">
                    <v-card-text class="py-6 d-flex align-center">
                      <v-avatar size="52" class="mr-4 avatar-soft primary">
                        <v-icon color="white">mdi-printer</v-icon>
                      </v-avatar>
                      <div>
                        <div class="menu-title">Passet Printing</div>
                        <div class="menu-desc">Formulir cetak label passet produksi</div>
                      </div>
                      <v-spacer></v-spacer>
                      <v-icon color="#64B5F6">mdi-chevron-right</v-icon>
                    </v-card-text>
                  </v-card>
                </v-col>

                <v-col cols="12" md="6">
                  <v-card class="menu-card checker elevation-2" :ripple="true" @click="gotoLotChecker">
                    <v-card-text class="py-6 d-flex align-center">
                      <v-avatar size="52" class="mr-4 avatar-soft success">
                        <v-icon color="white">mdi-clipboard-check-outline</v-icon>
                      </v-avatar>
                      <div>
                        <div class="menu-title">Checker Lot Process</div>
                        <div class="menu-desc">Validasi dan pengecekan lot produksi</div>
                      </div>
                      <v-spacer></v-spacer>
                      <v-icon color="#81C784">mdi-dots-horizontal</v-icon>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
            </div>
          </div>
        </v-sheet>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'ManufactureDashboard',
  methods: {
    gotoPassetPrinting() {
      this.$router && this.$router.push({ name: 'passetPrinting' })
    },
    gotoLotChecker() {
      this.$router && this.$router.push({ name: 'lotChecker' })
    },
    drawBackground() {
      const canvas = this.$refs.bgCanvas
      if (!canvas) return
      const container = canvas.parentElement
      const w = container.clientWidth
      const h = 220
      canvas.width = w
      canvas.height = h
      const ctx = canvas.getContext('2d')
      ctx.clearRect(0, 0, w, h)
      // soft blobs matching palette
      const g1 = ctx.createRadialGradient(w * 0.25, h * 0.5, 10, w * 0.25, h * 0.5, 170)
      g1.addColorStop(0, 'rgba(144, 202, 249, 0.35)')
      g1.addColorStop(1, 'rgba(144, 202, 249, 0)')
      ctx.fillStyle = g1
      ctx.beginPath()
      ctx.arc(w * 0.25, h * 0.55, 150, 0, Math.PI * 2)
      ctx.fill()

      const g2 = ctx.createRadialGradient(w * 0.8, h * 0.2, 10, w * 0.8, h * 0.2, 150)
      g2.addColorStop(0, 'rgba(165, 214, 167, 0.35)')
      g2.addColorStop(1, 'rgba(165, 214, 167, 0)')
      ctx.fillStyle = g2
      ctx.beginPath()
      ctx.arc(w * 0.8, h * 0.25, 140, 0, Math.PI * 2)
      ctx.fill()
    }
  },
  mounted() {
    this.$nextTick(() => this.drawBackground())
    window.addEventListener('resize', this.drawBackground)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.drawBackground)
  }
}
</script>

<style scoped>
.mo-bg {
  background: linear-gradient(180deg, #FAFCFF 0%, #FFFFFF 70%);
}
.mo-toolbar {
  background: linear-gradient(135deg, #90CAF9 0%, #A5D6A7 100%);
}
.mo-panel {
  background: #fff;
  border-radius: 16px;
  overflow: hidden;
}
.bg-canvas {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 220px;
  pointer-events: none;
}

.menu-card {
  border: 1px solid rgba(144, 202, 249, 0.25);
  border-radius: 14px;
  transition: transform .12s ease, box-shadow .15s ease, border-color .12s ease;
  background: linear-gradient(180deg, #FFFFFF 0%, #F8FBFF 100%);
}
.menu-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 18px rgba(0,0,0,0.08) !important;
  border-color: rgba(144, 202, 249, 0.55);
}
.menu-title { font-weight: 700; font-size: 1.05rem; color: #263238; }
.menu-desc { font-size: .92rem; color: #607d8b; }

.avatar-soft.primary { background: linear-gradient(135deg, #64B5F6, #90CAF9); }
.avatar-soft.success { background: linear-gradient(135deg, #81C784, #A5D6A7); }
</style>
